@for (error of errors; track error) {
  <div
    class="error"
    >
    @if (error.toString() !== 'true') {
      @if ('graphql-errors.' + (error | lowercase) | translate; as translated) {
        @if (translated !== 'graphql-errors.' + error.toLowerCase()) {
          {{ translated }}
        }
      }
    }
  </div>
}


